import { Toast as BaseUIToast } from '@base-ui/react/toast';
import { use } from 'react';

import { LocalizationContext } from '@hrworks/localization';

import { ToastItem } from '../ToastItem/ToastItem';
import { S } from './ToastViewport.styles';

export const ToastViewport = () => {
  const { toasts } = BaseUIToast.useToastManager();
  const { translate } = use(LocalizationContext);

  return (
    <S.Viewport className={S.cls.Viewport} aria-label={translate('toast-notifications')}>
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </S.Viewport>
  );
};
